<div class="c-field-value" [ngSwitch]="data | lowercase">
  <ng-container *ngSwitchCase="'system'">
    <span class="c-field-value__text" i18n="@@common.system">System</span>
  </ng-container>
  <ng-container *ngSwitchCase="'error'">
    <span class="c-field-value__text text-color--yellow" i18n="@@common.error">Error</span>
  </ng-container>
  <ng-container *ngSwitchCase="'danger'">
    <span class="c-field-value__text text-color--orange" i18n="@@common.danger">Danger</span>
  </ng-container>
  <ng-container *ngSwitchCase="'critical'">
    <span class="c-field-value__text text-color--red" i18n="@@common.critical">Critical</span>
  </ng-container>
  <ng-container *ngSwitchCase="'new_affiliate_tracker'">
    <span class="c-field-value__text" i18n="@@common.default_postback">Default Postback</span>
  </ng-container>
  <ng-container *ngSwitchCase="'new_global_postback'">
    <span class="c-field-value__text text-color--green" i18n="@@common.global_postback">Global Postback</span>
  </ng-container>
  <ng-container *ngSwitchCase="'new_affiliate_signup'">
    <span class="c-field-value__text text-color--green" i18n="@@affiliate.new_affiliates">New Affiliate</span>
  </ng-container>
  <ng-container *ngSwitchCase="'new_affiliate_invoice'">
    <span class="c-field-value__text text-color--green" i18n="@@finance.new_invoice">New Invoice</span>
  </ng-container>
  <ng-container *ngSwitchCase="'affiliate_offer_access'">
    <span class="c-field-value__text text-color--primary" i18n="@@offer.access">Offer Access</span>
  </ng-container>
  <ng-container *ngSwitchDefault>
    <span class="c-field-value__text text-color--green" i18n="@@common.new">New</span>
  </ng-container>
</div>
